import { CSSProperties } from "react";

export type ButtonProps = {
  title: string;
  type?: ButtonType;
  size?: ButtonSize;
  onClick?: () => any;
  disabled?: boolean;
  loading?: boolean;
  leftIcon?: JSX.Element;
  rightIcon?: JSX.Element;
  buttonStyle?: CSSProperties;
  textStyle?: CSSProperties;
};

export enum ButtonType {
  Primary = "primary",
  Secondary = "secondary",
  Inverse = "inverse",
  Danger = "danger",
}

export enum ButtonSize {
  Regular = "regular",
  Small = "small",
}
